import React, { useEffect, useState, useCallback } from "react";
import { getAuditLogs } from "../../api/adminApi";

function formatEventType(eventType) {
  return eventType
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function formatDateTime(value) {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export default function AuditTimelineAdmin({ documentId, refreshKey = 0 }) {
  const [logs, setLogs] = useState([]);

  const load = useCallback(async () => {
    const res = await getAuditLogs(documentId);
    setLogs(res.data);
  }, [documentId]);

  useEffect(() => {
    if (!documentId) return;
    load();
    const interval = setInterval(load, 10000);
    return () => clearInterval(interval);
  }, [documentId, refreshKey, load]);

  return (
    <div className="card">
      {logs.length === 0 ? (
        <div className="empty-state">No audit events available.</div>
      ) : (
        <div className="timeline">
          {logs.map((log) => (
            <div key={log.id} className="timeline-item">
              <div className="timeline-dot" />

              <div style={{ fontWeight: 700, marginBottom: 6 }}>
                {formatEventType(log.eventType)}
              </div>

              <div style={{ marginBottom: 8 }}>{log.eventDetails || "-"}</div>

              <div className="helper-text">
                <div>
                  <strong>Time:</strong> {formatDateTime(log.createdAt)}
                </div>
                <div>
                  <strong>Signer ID:</strong> {log.signerId || "-"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
